export default {
  token: null,
  getAuthHeader () {
    return {
      Authorization: 'Bearer ' + this.token
    }
  },
  setToken (newToken) {
    if (this.token !== newToken) {
      this.token = newToken
      if (newToken) {
        localStorage.setItem('bioplan_token', newToken)
      } else {
        localStorage.removeItem('bioplan_token')
      }
    }
  },
  checkLocalToken () {
    let localToken = localStorage.getItem('bioplan_token')
    if (localToken) {
      this.setToken(localToken)
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/index.js